import { FlexiText } from "appworks/graphics/elements/flexi-text";
import { Services } from "appworks/services/services";
import { SignalBinding } from "signals";
import { slotModel } from "slotworks/model/slot-model";
import { AbstractControl } from "../../abstract-control";

export class TotalStakeTextControl extends AbstractControl {
    protected updateStakeBinding: SignalBinding;

    constructor(protected label: FlexiText) {
        super();

        this.updateStakeBinding = slotModel.onUpdate.add(() => this.updateStake());
        this.updateStake();
    }

    public destroy(): void {
        this.updateStakeBinding.detach();
    }

    protected updateStake(): void {
        this.label.setText(Services.currency.format(Services.bet.getTotalStake()));
    }
}
